import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

/**
 * Compact badge showing whether a lead is still listed online.
 *
 * Bron: **Supabase** via `listing_urls` (zelfde logica als de chip op de
 * detail-pagina). Wanneer Supabase alle URLs heeft verwijderd, beschouwen we
 * het pand als offline. Dit vervangt de oude lokale scraper-bron zodat
 * overzicht en detail altijd hetzelfde tonen.
 *
 *  - `listing_urls.length > 0`  → groen "Online"
 *  - `listing_urls.length === 0` → rood "Offline"
 */
export default function LiveStatusBadge({ lead, size = "sm" }) {
  if (!lead) return null;
  const urls = lead.listing_urls || [];
  const isOnline = urls.length > 0;
  const cls = isOnline
    ? "text-[#1F8B5F] bg-[#E6F4EC] border-[#A6D8B7]"
    : "text-[#B43232] bg-[#FBE7E7] border-[#EFBABA]";
  const Icon = isOnline ? CheckCircle2 : XCircle;
  const label = isOnline ? "Online" : "Offline";
  const tip = isOnline
    ? `Pand staat nog online bij Mondo Vastgoed (${urls.length} ${urls.length === 1 ? "URL" : "URLs"})`
    : "Geen URLs in Supabase — pand staat niet meer als zoekertje online";
  return (
    <span title={tip}
          data-testid={`live-status-${lead.id}`}
          data-live-status={isOnline ? "active" : "offline"}
          className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border ${cls} ${size === "sm" ? "text-[10px]" : "text-[11px]"} font-medium`}>
      <Icon size={size === "sm" ? 10 : 12} />
      {label}
    </span>
  );
}
